export const aboutVisionSection = {
  label: 'Our Vision',
  titleLine1: 'Shaping The Future of ',
  titleAccent: 'Global Metal Trading Excellence',
  image: '/assets/about-vision-port.png',
  imageAlt:
    'Global port with metal coils, container ship, and international trade network at sunset',
  paragraphs: [
    'To become a globally recognized and trusted metals trading company, known for delivering excellence through consistent quality, reliability, and operational efficiency.',
    'The company aspires to build a strong international presence by developing strategic global partnerships, expanding its trading network across key markets, and creating a sustainable and scalable business model.',
    'With a focus on long-term growth, Torbit Metals Private Limited aims to establish itself as a preferred partner in the global metals supply chain, driven by trust, professionalism, and value creation for all stakeholders.',
  ],
  items: [
    {
      id: 'recognition',
      title: 'Global Recognition',
      text: 'Become a trusted name in international metal trading markets.',
      icon: 'recognition',
    },
    {
      id: 'partnerships',
      title: 'Strategic Partnerships',
      text: 'Build strong and sustainable global business relationships.',
      icon: 'partnerships',
    },
    {
      id: 'expansion',
      title: 'International Expansion',
      text: 'Expand trading operations across key global markets.',
      icon: 'expansion',
    },
    {
      id: 'growth',
      title: 'Sustainable Growth',
      text: 'Develop scalable and future-ready business models.',
      icon: 'growth',
    },
    {
      id: 'excellence',
      title: 'Operational Excellence',
      text: 'Maintain efficiency, reliability and consistent performance.',
      icon: 'excellence',
    },
    {
      id: 'value',
      title: 'Value Creation',
      text: 'Deliver long-term value for customers and stakeholders.',
      icon: 'value',
    },
  ],
}

export const aboutMissionSection = {
  label: 'Our Mission',
  titleLine1: 'Building Strong Partnerships Through ',
  titleAccent: 'Quality, Integrity & Global Reach',
  description:
    'Our mission is to deliver high-quality metal solutions, maintain transparency in operations, and create sustainable business relationships worldwide.',
  backgroundImage: '/assets/products-hero-metals.png',
  items: [
    {
      id: 'network',
      title: 'Global Sourcing Network',
      text: 'Establish a strong global sourcing and distribution network.',
      icon: 'network',
    },
    {
      id: 'quality',
      title: 'Quality Products',
      text: 'Deliver high-quality metals with competitive pricing.',
      icon: 'target',
    },
    {
      id: 'transparency',
      title: 'Transparency & Integrity',
      text: 'Maintain transparency and professionalism in all business operations.',
      icon: 'shield',
    },
    {
      id: 'relationships',
      title: 'Long-Term Relationships',
      text: 'Build sustainable and mutually beneficial business partnerships.',
      icon: 'handshake',
    },
    {
      id: 'expansion',
      title: 'Global Expansion',
      text: 'Continuously expand into new international markets.',
      icon: 'global',
    },
    {
      id: 'supply-chain',
      title: 'Supply Chain Excellence',
      text: 'Ensure efficient and timely execution through strong logistics and supply chain.',
      icon: 'truck',
    },
  ],
}

export const aboutHero = {
  eyebrow: 'About Us',
  titleLine1: 'Building Strength',
  titleAccent: 'Delivering ',
  titleLine2: 'Trust',
  description:
    'Torbit Metals Private Limited is a trusted name in the global metal trading industry, committed to delivering high-quality metal products with reliability, integrity, and excellence.',
  primaryCta: { label: 'Our Journey', to: '#about-company' },
  secondaryCta: { label: 'Contact Us', to: '/contact#inquiry-form' },
}
